<template>
  <AppFormGroup>
    <SubHeading keypath="headings.references" />

    <div class="flex flex-col lg:flex-row lg:gap-4">
      <AppField
        :path-prefix="applicantType"
        path="reference.firstName"
        class="lg:basis-1/4"
      />

      <AppField
        :path-prefix="applicantType"
        path="reference.lastName"
        class="lg:basis-1/4"
      />
      <AppField
        :path-prefix="applicantType"
        path="reference.phoneNumber"
        class="lg:basis-1/4"
      />
      <AppField
        :path-prefix="applicantType"
        path="reference.relationship"
        class="lg:basis-1/4"
      />
    </div>
  </AppFormGroup>
</template>

<script setup lang="ts">
  import {
    AppField,
    AppFormGroup,
  } from "@versatile-credit-apply/components/form"

  import { useProviderI18n } from "@versatile-credit-apply/sdk"
  import type { FormSectionProps } from "./form-section-api"

  const props = defineProps<FormSectionProps>()

  useProviderI18n(() => props.providerKey)
</script>

<i18n lang="yaml" locale="en">
appFields:
  phoneNumber:
    label: Phone Number
  relationship:
    label: Relationship
headings:
  references: References

</i18n>

<i18n lang="yaml" locale="easypay_standard_en">
headings:
  references: Contact Information of Relative (or Friend)
</i18n>
